import { makeEnvironmentProviders } from '@angular/core';
import { FRESH_DESK_CONFIG, FreshdeskConfig } from './freshdesk.model';
import { FreshdeskService, WindowRefService } from './freshdesk.service';

function _provideFreshDesk(config: FreshdeskConfig) {
  return [
    FreshdeskService,
    WindowRefService,
    { provide: FRESH_DESK_CONFIG, useValue: config },
  ];
}

export function provideFreshDesk(config: FreshdeskConfig) {
  return makeEnvironmentProviders(_provideFreshDesk(config));
}
